import type { SVGProps } from 'react';

export function SvgInstagram(props: SVGProps<SVGSVGElement>): React.ReactElement {
  return (
    <svg
      {...props}
      fill="none"
      height="1em"
      viewBox="0 0 24 24"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M20.4 5.4a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0" fill="currentColor" />
      <path
        clipRule="evenodd"
        d="M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12m0-2.4a3.6 3.6 0 1 0 0-7.2 3.6 3.6 0 0 0 0 7.2"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M0 11.52c0-4.032 0-6.049.785-7.589A7.2 7.2 0 0 1 3.93.785C5.471 0 7.488 0 11.52 0h.96c4.032 0 6.049 0 7.589.785a7.2 7.2 0 0 1 3.146 3.146C24 5.471 24 7.488 24 11.52v.96c0 4.032 0 6.049-.785 7.589a7.2 7.2 0 0 1-3.146 3.146C18.529 24 16.512 24 12.48 24h-.96c-4.032 0-6.049 0-7.589-.785A7.2 7.2 0 0 1 .785 20.07C0 18.529 0 16.512 0 12.48zM11.52 2.4h.96c2.056 0 3.453.002 4.534.09 1.052.086 1.59.242 1.965.433a4.8 4.8 0 0 1 2.098 2.098c.191.375.347.913.433 1.965.088 1.08.09 2.478.09 4.534v.96c0 2.056-.002 3.453-.09 4.534-.086 1.052-.242 1.59-.433 1.965a4.8 4.8 0 0 1-2.098 2.098c-.375.191-.913.347-1.965.433-1.08.088-2.478.09-4.534.09h-.96c-2.056 0-3.453-.002-4.534-.09-1.052-.086-1.59-.242-1.965-.433a4.8 4.8 0 0 1-2.098-2.098c-.191-.375-.347-.913-.433-1.965-.088-1.08-.09-2.478-.09-4.534v-.96c0-2.056.002-3.453.09-4.534.086-1.052.242-1.59.433-1.965a4.8 4.8 0 0 1 2.098-2.098c.375-.191.913-.347 1.965-.433 1.08-.088 2.478-.09 4.534-.09"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}
